import {effect, Injectable, OnDestroy, signal} from '@angular/core';
import {ZimService} from './zim.service';
import {firstValueFrom, Subscription} from 'rxjs';
import {LoginService} from '../pages/login/services/login.service';
import {getUserInfo} from '../utils/utils';
import {ToastrService} from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class TokenRenewService implements OnDestroy {
  tokenWillExpireSubscription?: Subscription;
  loggedOutErrorSubscription?: Subscription;
  invalidTokenErrorSubscription?: Subscription;
  kickedOutSubscription?: Subscription;

  refreshingToken = signal<boolean>(false);

  epochInMilliseconds = Date.now();

  constructor(
    private zimService: ZimService,
    private loginService: LoginService,
    private toastService: ToastrService
  ) {
    effect(() => {
      let tokenExpired = zimService.tokenExpired();
      if (tokenExpired) {
        sessionStorage.removeItem('token_zego');
        this.refreshZegoToken(false).then();
      }
    });
    this.registerHandlers();
  }

  registerHandlers() {
    this.tokenWillExpireSubscription = this.zimService.tokenWillExpire$.subscribe(() => {
      this.refreshZegoToken(true).then();
    });
    this.loggedOutErrorSubscription = this.zimService.apiCallError$.subscribe(res => {
      // 6000121: User is not logged in (connections probably happened)
      if (res.code === 6000121) {
        this.handleLoggedOut();
      }
    });
    this.invalidTokenErrorSubscription = this.zimService.apiCallError$.subscribe(res => {
      // 6000103: Token is invalid.
      // 6000106: Token expired.
      if (res.code === 6000103 || res.code === 6000106) { // token is invalid: an empty token was passed
        this.handleInvalidOrExpiredToken();
      }
    });
    this.kickedOutSubscription = this.zimService.kickedOut$.subscribe(() => {
      this.handleLoggedOut();
    });
  }

  ngOnDestroy() {
    this.tokenWillExpireSubscription?.unsubscribe();
    this.loggedOutErrorSubscription?.unsubscribe();
    this.invalidTokenErrorSubscription?.unsubscribe();
    this.kickedOutSubscription?.unsubscribe();
  }

  private async refreshZegoToken(isRenew: boolean, showToast = false) {
    if (this.refreshingToken()) {
      return;
    }

    this.refreshingToken.set(true);
    const userInfo = getUserInfo();

    const { zegoId } = userInfo

    try {
      let res = await firstValueFrom(this.loginService.getTokenZego(zegoId));
      sessionStorage.setItem('token_zego', res.data.data);
      if (isRenew) {
        await this.zimService.getZIM()?.renewToken(res.data.data);
      } else {
        await this.zimService.login(zegoId, res.data.data);
        this.zimService.syncPrivacySettings().then();
        // window.location.reload();
        if (showToast) {
          this.toastService.info('Đã kết nối lại', undefined, {timeOut: 5000});
        }
      }
    } catch (err: any) {
      // TODO(ducvm18): Handle 6000105 "Request timeout"
      console.error('Failed to get zego token', err);
    } finally {
      this.refreshingToken.set(false);
    }
  }

  handleLoggedOut() {
    /**
     * We may be kicked early into the app (no token yet?), this is normal.
     * If we're in that phase (5s after this service's init), we can just do a reconnection flow.
     */

    let now = Date.now();
    if ((now - this.epochInMilliseconds) > 5000) {
      alert('Bạn đang đăng nhập trên quá nhiều máy! Bấm OK hoặc Close để sử dụng trên tab này.');
    }

    this.refreshZegoToken(false, true).then();
  }

  handleInvalidOrExpiredToken() {
    this.refreshZegoToken(false).then();
  }

  login() {
    return this.refreshZegoToken(false)
  }
}
